module.exports = __webpack_public_path__ + "images/blog-paper-pads-clips-pencils-markers-600w.jpg";